import $ from 'jquery';
import * as Utils from 'lib/utils';

const $D = $(document);

$.registerUI('popover', {
  init() {
    this.find('[data-popover]').each(function () {
      const $obj = $(this);
      const data = $obj.data();
      const color = data.color;
      const container = data.container || false;
      const boundary = data.boundary || 'scrollParent';
      const trigger = data.trigger || 'click';
      const href = data.target || $obj.attr('href');
      const title = data.title || $obj.attr('title') || '';
      const clone = Utils.toBoolean(data.clone, false);
      const arrow = Utils.toBoolean(data.arrow, true);
      const delayShow = Utils.toInt(data.delayShow, 300);
      const delayHide = Utils.toInt(data.delayHide, 300);
      const size = data.size;
      let timer;

      let delay = Utils.toInt(data.delay, 300);
      if (data.delay === undefined) delay = { show: delayShow, hide: delayHide };

      let html = Utils.toBoolean(data.html, false);
      let content = data.content;

      if (!content) {
        if (href) content = $(href);
        else {
          content = $obj.find('.popover');
          if (!content.length) content = $obj.parent().find('.popover');
        }

        if (!content.length) throw new Error('Unable to find popover target');
        else if (clone !== false) content = content.clone();

        html = true;
      }

      $obj
        .popover({
          container: container ? $obj.closest(container) : false,
          boundary,
          animation: Utils.toBoolean(data.animation, true),
          placement: data.placement || 'top',
          delay: trigger === 'click' ? 0 : delay,
          customClass: data.class || '',
          html,
          title,
          content,
          trigger: trigger === 'hover' ? 'manual' : trigger,
        })
        .on('inserted.bs.popover', () => {
          const $tip = $($obj.data('bs.popover').tip);

          if (!arrow) $tip.addClass(`no-arrow`);
          if (title) $tip.addClass('has-header');
          if (color) $tip.addClass(`popover-${color}`);

          if (['sm', 'small'].includes(size)) $tip.addClass('popover-sm');
          if (['md', 'medium'].includes(size)) $tip.addClass('popover-md');
          if (['lg', 'large'].includes(size)) $tip.addClass('popover-lg');
          if (['xl'].includes(size)) $tip.addClass('popover-xl');

          if (content instanceof $) content.removeClass('popover d-none').show();

          $tip.off('click').on('click', '.popover-menu-item', evt => {
            $obj.trigger('menu.bs.popover', $(evt.currentTarget).data('menu'));
            $obj.popover('hide');
          });
        });

      if (trigger === 'hover') {
        $obj
          .on('mouseenter', () => {
            const wait = delay.show >= 0 ? delay.show : delay;

            clearTimeout(timer);
            timer = setTimeout(() => $obj.popover('show'), wait);
          })

          .on('mouseleave', () => {
            const wait = delay.hide >= 0 ? delay.hide : delay;

            clearTimeout(timer);
            timer = setTimeout(() => $obj.popover('hide'), wait);
          })

          .on('shown.bs.popover', () => {
            $($obj.data('bs.popover').tip)
              .on('mouseenter', () => clearTimeout(timer))
              .on('mouseleave', () => {
                const wait = delay.hide >= 0 ? delay.hide : delay;

                clearTimeout(timer);
                timer = setTimeout(() => $obj.popover('hide'), wait);
              });
          })

          .on('hidden.bs.popover', () => {
            $($obj.data('bs.popover').tip).off('mouseenter mouseleave');
          });
      } else if (trigger === 'click') {
        $obj
          .on('shown.bs.popover', () => {
            $D.on(`click.${$obj.data('bs.popover').tip.id}`, evt => {
              if ($(evt.target).closest('.popover').length === 0 && !$(evt.target).hasClass('select2-selection__choice__remove')) $obj.popover('hide');
            });
          })

          .on('hidden.bs.popover', () => {
            $D.off(`click.${$obj.data('bs.popover').tip.id}`);
          });
      }
    });

    return this;
  },

  hide() {
    this.find('[data-popover]').each(function () {
      const $obj = $(this);
      const $tip = $($obj.data('bs.popover').tip);
      if ($tip.is('.show')) $obj.popover('hide');
    });

    return this;
  },
});
